import React, { Component } from 'react';
import Header from '../.././Header';
import ProjectCard from '.././ProjectCard';
import classnames from 'classnames';
import './style.sass';

export default class AngelList extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    const { className } = this.props;

    const navLinks = [
      {path: "/projects", title: "Projects"}
    ]

    var work = [
      {title: "Source", subtitle: "Launching a subscription service for sourcing candidates", timespan: "2017", slug: "angellist/source" },
      {title: "Talent Workflows", subtitle: "Improving recruiter workflows and redesigning product navigation", timespan: "2017", slug: "angellist/talent" },
    ]

    return (
      <div className={classnames('AngelList', className)}>
        <Header links={navLinks} />
        <div className="container">
          <div className="section">
            <div className="section-header">
              AngelList
            </div>
            <div className="Projects-projects">
              {
                Object.keys(work).map(function(project) {
                  var title = work[project]['title'];
                  var subtitle = work[project]['subtitle'];
                  var timespan = work[project]['timespan'];
                  var slug = work[project]['slug'];
                  return (
                    <ProjectCard
                      title={title}
                      subtitle={subtitle}
                      timespan={timespan}
                      slug={slug}
                    />
                  );
                })
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects/AngelList/index.js